import PageComponent from '../base/PageComponent';
import sidr from 'sidr/dist/jquery.sidr';

export default class Navigation extends PageComponent {

    constructor(domElement) {
        super(domElement);
        this.mobileNavBreakPoint = 992;
    }

    init() {
        this.mobileNav();
        this.onWindowResize();
        this.onWindowScroll();
    }

    mobileNav() {
        $('.mobile-menu-button').sidr({
            side: 'right',
            speed: 500,
            onOpen: function () {
                $('#sidr').css('opacity', 1);
            }
        });
    }

    onWindowScroll() {
        let windowWidth = $(window).width();

        if (windowWidth >= this.mobileNavBreakPoint) {
            // if ($('body').hasClass('home')) {
            //     if ($(window).scrollTop() > 1) {
            //         $('.navbar-fixed-top').addClass("sticky");
            //     }
            //     else {
            //         $('.navbar-fixed-top').removeClass("sticky");
            //     }
            // }
        }
    }

    onWindowResize() {
        let windowWidth = $(window).width();

        // if (windowWidth >= this.mobileNavBreakPoint) {
        //     if (!$('body').not().hasClass('home')) {
        //         $('.navbar-fixed-top').addClass('sticky');
        //     }
        //
        //
        //     if ($(this).scrollTop() > 1) {
        //         $('body.home .navbar-fixed-top').addClass("sticky");
        //     }
        //     else {
        //         $('body.home .navbar-fixed-top').removeClass("sticky");
        //     }
        // }
        // else {
        //     $('.navbar-fixed-top').removeClass('sticky');
        // }
    }
}


// WEBPACK FOOTER //
// ./javascript/components/Navigation.js